<template>
  <div class="tg-header--logo">
    <tg-logo @click.native="handleClick" :site="site"></tg-logo>
  </div>
</template>

<script>
import TgLogo from "@/components/icon/TgLogo";

export default {
  name: "TgHeaderLogo",
  components: {
    TgLogo,
  },
  props: {
    site: String,
  },
  methods: {
    handleClick() {
      window.location.href = window.location.origin;
    },
  },
};
</script>
